var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"criteria"},[_c('span',{staticClass:"criteria-icon"},[_c('font-awesome-icon',{style:({ fontSize: _vm.iconSize }),attrs:{"icon":_vm.criteriaIcon}})],1),_c('span',{staticClass:"criteria-name"},[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }